import React from 'react';

// Thin blinking text caret for the request bar's intro typewriter
export function TypingCaret() {
  return <span className="caret-blink ml-[2px] inline-block h-[20px] w-px shrink-0 bg-ink" aria-hidden="true" data-id="element-1201" data-mp="5rsg59gu6adp" />;
}